"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQuestionSelectionActions = void 0;
var questionnaireActions = _interopRequireWildcard(require("../../store/questionnaire/questionnaireActions"));
var _questionnaireUtil = require("../../utils/questionnaireUtil");
var _useAppDispatch = require("../useAppDispatch");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const useQuestionSelectionActions = question => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const shouldAffectBudget = !(0, _questionnaireUtil.isBudgetQuestion)(question) && !question.shouldNotAffectRecommendation;
  const checkDefaultChoice = () => {
    var _question$choices;
    const defaultChoice = (_question$choices = question.choices) === null || _question$choices === void 0 ? void 0 : _question$choices.find(choice => choice.isDefault);
    if (defaultChoice) {
      addSelection(defaultChoice.text);
    }
  };
  const addSelection = selection => {
    dispatch(questionnaireActions.addSelection(selection));
    if (shouldAffectBudget) {
      dispatch((0, questionnaireActions.resetBudgetAndRecommendation)());
    }
  };
  const removeSelection = selection => {
    dispatch(questionnaireActions.removeSelection(selection));
    if (shouldAffectBudget) {
      dispatch((0, questionnaireActions.resetBudgetAndRecommendation)());
    }
  };
  const replaceSelection = (selection, index) => {
    dispatch(questionnaireActions.replaceSelection(selection, index));
    if (shouldAffectBudget) {
      dispatch((0, questionnaireActions.resetBudgetAndRecommendation)());
    }
  };
  return {
    addSelection,
    removeSelection,
    replaceSelection,
    checkDefaultChoice
  };
};
exports.useQuestionSelectionActions = useQuestionSelectionActions;